/**
 * A `direct_session.progress` event: the task's live line and, when the line
 * is a tool step of a turn Denker sent (`step`), that step in the task chat.
 * The step's id is the one the chat's activity history replays, so the live
 * step and the reloaded one are one row.
 */
import { asActivityLabel } from "@/lib/activity-label";
import { useDirectSessionProgressStore } from "@/stores/direct-session-progress-store";
import type { FrameApplyContext } from "./companion-frame-reducer-shared";

function field(record: Record<string, unknown>, key: string): string {
  const value = record[key];
  return typeof value === "string" ? value : "";
}

export function applyDirectSessionProgress(
  data: Record<string, unknown>,
  ctx: FrameApplyContext,
): void {
  useDirectSessionProgressStore.getState().apply(data);
  const step = data.step;
  const text = typeof data.text === "string" ? data.text.trim() : "";
  if (!step || typeof step !== "object" || Array.isArray(step) || !text) return;
  const record = step as Record<string, unknown>;
  const id = field(record, "id");
  const executionId = field(record, "execution_id");
  const conversationId = field(record, "conversation_id");
  if (!id || !executionId || !conversationId) return;
  const label = asActivityLabel(data.label);
  const startedAt = field(record, "execution_started_at");
  ctx.conversationStore.getState().pushMessage({
    id,
    role: "system",
    content: text,
    ...(label ? { contentLabel: label } : {}),
    activityKind: "tool_call",
    executionId,
    conversationId,
    ...(startedAt ? { executionStartedAt: startedAt } : {}),
    createdAt: field(record, "created_at") || new Date().toISOString(),
  });
}
